export const selectShops = (state) => state.shops.allShops;
